export const AxleLoadIcon = () => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M50.8799 20.7207L30.0004 39.4647C28.3753 38.0052 28.3751 38.0051 28.3751 38.0051C28.3751 38.0051 28.3748 38.0052 26.7491 36.5455L9.12083 20.7207C8.79364 20.4266 8.56269 20.039 8.45861 19.6093C8.35454 19.1796 8.38224 18.7282 8.53807 18.3147C8.69389 17.9013 8.97046 17.5455 9.33111 17.2944C9.69175 17.0434 10.1194 16.909 10.5574 16.9091H17.0384V6H21.3591V21.2727H16.2391L30.0004 33.6262L43.7617 21.2727H38.6417V6H42.9623V16.9091H49.4433C49.8813 16.909 50.309 17.0434 50.6697 17.2944C51.0303 17.5455 51.3069 17.9013 51.4627 18.3147C51.6185 18.7282 51.6462 19.1796 51.5421 19.6093C51.4381 20.039 51.2071 20.4266 50.8799 20.7207Z"
                fill="url(#paint0_linear_408_3834)"/>
            <path
                d="M3.5 54L3.5 41.2H6.95652V45.8545H25.7263C26.41 44.1488 28.0659 42.9455 30 42.9455C31.9341 42.9455 33.59 44.1488 34.2737 45.8545H53.0435V41.2H56.5V54H53.0435V49.3455H34.2737C33.59 51.0512 31.9341 52.2545 30 52.2545C28.0659 52.2545 26.41 51.0512 25.7263 49.3455H6.95652V54H3.5Z"
                fill="url(#paint1_linear_408_3834)"/>
            <defs>
                <linearGradient id="paint0_linear_408_3834" x1="33.6552" y1="-20.8235" x2="96.5335" y2="87.5846"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
                <linearGradient id="paint1_linear_408_3834" x1="33.6552" y1="-20.8235" x2="96.5335" y2="87.5846"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
            </defs>
        </svg>
    );
};